export const login = () => {
    window.location.href = "https://app.makemybrand.ai/login";
}